import { forwardRef, useImperativeHandle } from 'react';
import { Select } from 'antd';
import { useGlobal } from '@/utils/useGlobal';
import EFEmail from '@/components/UI/svg/Footer/Icon/EFEmail';
import SelectSuffixIcon from '@/components/UI/svg/Delta2/Icon/SelectSuffixIcon';
import mailchimpCss from '@/components/SignUpForm/Mailchimp/index.module.scss';

interface IExtraField {
    type: string;
    name: string;
    defaultValue?: string;
    data?: any[];
}

interface IMailchimpViewProps {
    action: string;
    extraFields?: IExtraField[];
    submitText?: string;
    placeholder?: string;
    disabled?: boolean;
}

const BaseFormView = ({ action, extraFields, submitText, placeholder, disabled }: IMailchimpViewProps, ref: any) => {
    const { useLang, useState, isMobile } = useGlobal();
    const { t } = useLang('shared');
    const { t: td } = useLang('product');
    const [selectVal, setSelectVal] = useState(null);
    const [inputValue, setInputValue] = useState('');

    const onInput = (e: any) => {
        setInputValue(e?.target.value.trim());
    };
    const calDisable = () => {
        const reg = /^[a-zA-Z0-9]+([-_.][A-Za-zd]+)*@([a-zA-Z0-9]+[-.])+[A-Za-zd]{2,10}$/;
        return !reg.test(inputValue);
    };

    const resetFiled = () => {
        setSelectVal(null);
    };

    useImperativeHandle(ref, () => ({
        resetFiled,
    }));

    const extraItem = extraFields?.map((field, i) => {
        const { type, name, data, defaultValue } = field;

        const onChange = (value: string) => {
            // const input = document.querySelector(`input#mce-${name}`) as HTMLInputElement
            // input && (input.value = value)
            setSelectVal(value);
        };

        if (!type) return null;
        if (type === 'hidden_input') {
            return <input name={name} id={`mce-${name}`} value={defaultValue} style={{ display: 'none' }} />;
        }

        if (type === 'select') {
            const options = data?.map((value, i) => {
                return {
                    key: value + i,
                    label: value,
                    value: value,
                };
            });
            return (
                <div className="mc-field-group select" data-name={name}>
                    <input value={selectVal} name={name} className="required cus-hidden" id={`mce-${name}`} aria-required="true" />
                    <Select
                        value={selectVal}
                        className={isMobile ? 'select select-h5' : 'select'}
                        options={options}
                        onChange={onChange}
                        placeholder="Country"
                        listItemHeight={54}
                        suffixIcon={<SelectSuffixIcon />}
                        dropdownClassName={mailchimpCss.dropClass}
                    />
                    <div className="custom_error_msg" style={{ display: 'none' }}></div>
                </div>
            );
        }
    });

    return (
        <div id="mc_embed_signup" className={mailchimpCss.mailchimp}>
            <form
                action={action}
                method="post"
                id="mc-embedded-subscribe-form"
                name="mc-embedded-subscribe-form"
                className="validate"
                target="_blank"
                noValidate
            >
                <div id="mc_embed_signup_scroll">
                    <div className="main">
                        {extraItem}
                        <div className="mc-field-group mc-input" data-name={'EMAIL'}>
                            <span className="email-icon">
                                <EFEmail />
                            </span>
                            <input
                                id="mce-EMAIL"
                                name="EMAIL"
                                type="email"
                                value={inputValue}
                                onInput={onInput}
                                className="required email"
                                placeholder={placeholder || t('common.email_holder')}
                            />
                            <div className="custom_error_msg" style={{ display: 'none' }}></div>
                        </div>
                        <div className="mc-action">
                            <button type="submit" disabled={calDisable() || disabled} name="subscribe" id="mc-embedded-subscribe" className="button">
                                {submitText || td('delta2.subscribe')}
                            </button>
                        </div>
                    </div>

                    <div id="custom-responses-msg" style={{ display: 'none' }}></div>
                    {/* raw validate */}
                    <div id="mce-responses" className="clear">
                        <div className="response" id="mce-error-response" style={{ display: 'none' }}></div>
                        <div className="response" id="mce-success-response" style={{ display: 'none' }}></div>
                    </div>
                    <div style={{ position: 'absolute', left: '-5000px' }} aria-hidden="true">
                        <input type="text" name="b_d002bf04842356c4c1c5221cf_bfd2f8459d" tabIndex={-1} value="" />
                    </div>
                </div>
            </form>
        </div>
    );
};

export default forwardRef(BaseFormView);
